/**
 * ヘッダーと同じロゴ（public/mikiwame-logo.svg）を、文字色に追従する形で埋め込んだもの。
 *
 * 元ファイルは中身が全て #FFFFFF で紫のヘッダー専用のため、明るい背景では見えない。
 * ここでは currentColor に置き換えてある。viewBox も元は "0 10 320 70" だが、
 * 中身は x=13〜242 にしか無く右に78ぶんの余白がぶら下がっていて、中央寄せにすると
 * 左へずれて見えるため、中身に合わせた範囲にしている。
 */
export default function MikiwameLogo({ width = 156 }: { width?: number }) {
  return (
    <svg
      viewBox="9 15 236 55"
      width={width}
      height={(width * 55) / 236}
      role="img"
      aria-label="MIKIWAME"
      style={{ display: 'block', color: 'inherit' }}
    >
      {/* 目のマーク */}
      <g transform="translate(40, 40)">
        <circle cx="0" cy="0" r="18" fill="none" stroke="currentColor" strokeWidth="2.5" />
        <path
          d="M -12 0 Q 0 -8, 12 0 Q 0 8, -12 0 Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          opacity="0.95"
        />
        <circle cx="0" cy="0" r="4" fill="currentColor" />
        <circle
          cx="0"
          cy="0"
          r="2"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.5"
          opacity="0.8"
        />
        <g opacity="0.6" stroke="currentColor" strokeWidth="1.5">
          <line x1="8" y1="-8" x2="14" y2="-14" />
          <line x1="11" y1="0" x2="18" y2="0" />
          <line x1="8" y1="8" x2="14" y2="14" />
        </g>
        <g opacity="0.4" fill="currentColor">
          <circle cx="-22" cy="0" r="1.5" />
          <circle cx="-26" cy="0" r="1" />
        </g>
      </g>
      {/* ロゴタイプ */}
      <text
        x="75"
        y="45"
        fontFamily="'Segoe UI', -apple-system, 'Helvetica Neue', 'Noto Sans JP', sans-serif"
        fontSize="28"
        fontWeight="600"
        fill="currentColor"
        letterSpacing="2"
      >
        MIKIWAME
      </text>
      <text
        x="75"
        y="62"
        fontFamily="'Noto Sans JP', 'Hiragino Sans', 'Yu Gothic', sans-serif"
        fontSize="11"
        fontWeight="400"
        fill="currentColor"
        letterSpacing="0.5"
        opacity="0.75"
      >
        AI-Powered Fact Discovery
      </text>
      <rect x="75" y="66" width="80" height="0.5" fill="currentColor" opacity="0.4" />
    </svg>
  );
}
